module.exports = __webpack_public_path__ + "static/media/categoryPagePicture.fefe82f0.png";